export default __webpack_public_path__ + "static/media/microPhone.bdb10aa4.svg";